if($('.type-detail').length){
    
    $('.p-info-wrapper').append($('.p-detail-inner-header h1').clone())
    $('.p-detail-info').clone().appendTo('.p-image')
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart'))
    var customMessage = '<div class="kontakt">'
        customMessage += '<div class="left">'
            customMessage += '<p>Tento produkt lze obohatit potiskem <br>či výšivkou. Kontaktujte nás.</p>'
            customMessage += '<ul>'
                customMessage += '<li>'+$('footer#footer .contact-box ul li span.mail').closest('li').html()+'</li>'
                customMessage += '<li>'+$('footer#footer .contact-box ul li span.tel').closest('li').html()+'</li>'
            customMessage += '</ul>'
        customMessage += '</div>'
        customMessage += '<div class="right">'
            customMessage += '<a href="/poptavka/" class="btn btn-default">Poptat</a>' 
        customMessage += '</div>' 
    customMessage += '</div>'
    $('.p-info-wrapper').append(customMessage)
    if($('.p-info-wrapper .variant-list').length){
        $('.p-info-wrapper .variant-list select[data-parameter-name*="Velikost"]').closest('.variant-list').after('<tr class="sizesTable"><td><p class="text-left"><a href="/user/documents/upload/informace/tabulkavelikosti.pdf" target="_blank">Tabulka velikostí</a></p></td></tr>')
        if($('.availability-value .default-variant').text().trim() === 'Zvolte variantu'){
            $('.availability-value .default-variant').hide()
        }
    }
}

if ($('.type-detail .variant-list').length) {

    $(document).ready(function() {
        $('select[data-parameter-name*="Velikost"]').each(function() {
            $(this).find('option').eq(1).prop('selected', true);
        });
    });
}